import { config } from "../../../config/config";
import { authHeaders, handleV2Error } from "../_helpers";
import { userConfigSchema, type UserConfig } from "../../../utils/zod/user";

export type { UserConfig };

export interface UpdateUserConfigInput {
  theme?: string;
  language?: string;
  preferences?: Record<string, unknown>;
}

export const updateUserConfigRequest = async (
  input: UpdateUserConfigInput,
  token: string,
): Promise<UserConfig> => {
  const response = await fetch(`${config.API_V2_URL}/v2/users/me/config`, {
    method: "PATCH",
    headers: authHeaders(token),
    body: JSON.stringify(input),
  });

  if (!response.ok) await handleV2Error(response);

  const { data } = await response.json();
  return userConfigSchema.parse(data);
};

export const getUserConfigRequest = async (
  token: string,
): Promise<UserConfig | null> => {
  const response = await fetch(`${config.API_V2_URL}/v2/users/me/config`, {
    method: "GET",
    headers: authHeaders(token),
  });

  if (!response.ok) await handleV2Error(response);

  const { data } = await response.json();
  if (data === null) return null;
  return userConfigSchema.parse(data);
};
